import { name, version } from '../package.json';

export default {
    rightAligned: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, right aligns the buttons in the container.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
